import { Injectable } from '@angular/core';
import { NgFlowchart } from '../model/flow.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DropDataService {

  dragStep: NgFlowchart.PendingStep | NgFlowchart.MoveStep;
  dragConnector: NgFlowchart.Connector;
  buildHITL = new BehaviorSubject<any>(null);
  selectAllSteps = new BehaviorSubject<boolean>(false);

  constructor() {}

  public setDragStep(ref: NgFlowchart.PendingStep) {
    this.dragStep = ref;
  }

  public getDragStep() {
    return this.dragStep;
  }

  public setDragConnector(ref: NgFlowchart.Connector) {
    this.dragConnector = ref;
  }

  public getDragConnector() {
    return this.dragConnector;
  }

  createHITLFlow(id)
  {
      this.buildHITL.next(id);
  }
  
}
